import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconDocs = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 18,
	viewBox: "0 0 14 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1 6H13",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 10H9",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 14H11",
			stroke: "currentColor",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		})
	]
});
export default SvgIconDocs;
